
<form *ngIf="isVersion2()" name="tableItemEditForm" #tableItemEditForm="ngForm">
  <div class="row">

    <div class="col-sm-6" *ngIf="!isMandatoryDocumentation">
      <div class="form-group" *ngIf="!item.isMandatoryFile">
        <label for="DesignationTypeCode"><span class="mandatory">*</span>{{'CardDocumentation.DocumentsTable.Designation' | translate}}</label>
        <select class="custom-select" [(ngModel)]="item.designationTypeCode" name="designationTypeCode" #designationTypeCode="ngModel" required
                (ngModelChange)="docDesignationChanged()"
                [dropdownTitle]="{value : item.designationTypeCode, dimensions : designationTypes }" nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of getFilteredDesignationTypes()" [value]="domain.value">
            {{domain.description}}
          </option>
          <!--Vai precisar de um versioncheck aqui-->
          <!--<option *ngFor="let domain of getFilteredDesignationTypes()" [value]="domain.code">
            {{domain.description}}
          </option>-->
        </select>
        <validation-message [control]="designationTypeCode"></validation-message>
      </div>
    </div>

    <!--<div class="col-sm-6">
      <div class="form-group">
        <label for="FileType"><span class="mandatory">*</span>{{'CardDocumentation.DocumentsTable.FileType' | translate}}</label>
        <select class="custom-select" [(ngModel)]="item.extensionTypeCode" name="extensionTypeCode" #extensionTypeCode="ngModel" required
                [dropdownTitle]="{value : item.extensionTypeCode, dimensions : fileTypes }" nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of fileTypes" [value]="domain.code">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="extensionTypeCode"></validation-message>
      </div>
    </div>-->


    <div class="col-sm-12" *ngIf="isMandatoryDocumentation">
      {{item.description}}
    </div>

    <div class="col-sm-12" [hidden]="!((item.fileID && isEdit) || uploadedFile)">
      <div class="fileinput-custom-1" (click)="downloadDocument()">
        <div class="content-file-wrapper">
          <div class="d-flex align-items-center">
            <span class="icon-doc"></span>
            <span class="text-file">
              <p class="m-0 text-filename">{{item.fileName}}</p>
              <p class="m-0 min-text">{{item.fileSizeKB}}KB</p>
            </span>
          </div>

          <button type="button" class="btn-icon text-primary hide-on-fieldset" aria-label="Editar" (click)="onClearFile(isEdit,true)">
            <span class="p-1 text-primary icon-trash"></span>
            &nbsp;Limpar
          </button>

        </div>
      </div>
    </div>


    <div class="col-sm-12" [hidden]="item.fileID || uploadedFile">
      <div class="fileinput-custom-2" appDrag (files)="onFileDropped($event)">
        <i class="icon-upload text-primary" aria-hidden="true"></i>
        <span>
          <label class="fileinput-bold-text">{{'CardDocumentation.DocumentsTable.File' | translate}}&nbsp;</label>
          <input class="form-control" type="file" id="input-file" #file name="file" accept="application/pdf" (click)="this.item.fileID=null;item.file= null;" (change)="onFileSelected($event)" [required]="true" style="display: none;">
          <a class="text-secondary">
            <label for="input-file" class="fileinput-bold-text">
            {{'CardDocumentation.DocumentsTable.Find' | translate}}
              </label>
          </a>
        </span>
        <span class="fileinput-custom-text-responsive">{{'CardDocumentation.DocumentsTable.ValidNameMessage1' | translate}}</span>
        <span class="fileinput-custom-text-responsive">{{'CardDocumentation.DocumentsTable.ValidNameMessage2' | translate}}</span>
        <span class="fileinput-custom-text-responsive">{{'CardDocumentation.DocumentsTable.ExtensionAndSize1' | translate}}</span>
        <span class="fileinput-custom-text-responsive">{{'CardDocumentation.DocumentsTable.ExtensionAndSize2' | translate}}</span>
        <span *ngIf="invalidFileSize" class="fileinput-custom-text-responsive" style="color:red">O ficheiro que pretende adicionar está vazio</span>
        <span *ngIf="invalidExceedsFileSize" class="fileinput-custom-text-responsive" style="color:red">O ficheiro excede o tamanho máximo permitido</span>
        <span *ngIf="invalidPDFFile" class="fileinput-custom-text-responsive" style="color:red">O formato do ficheiro que pretende adicionar não corresponde à sua extensão!</span>
        <span *ngIf="invalidFileFormat" class="fileinput-custom-text-responsive" style="color:red">O tipo de ficheiro fornecido não é válido.</span>
        <validation-message [control]="file"></validation-message>
      </div>
    </div>

    <div class="col-sm-1">&nbsp;</div>

    <div class="col-sm-6">
      <div class="form-group" [ngClass]="shouldEditName(item.designationTypeCode) ? '' : 'disabled'">
        <!-- File description type inputs-->
        <label for="Name"><span class="mandatory" *ngIf="shouldEditName(item.designationTypeCode)">*</span>{{'CardDocumentation.DocumentsTable.Name' | translate}}</label>
        <input class="form-control" type="text" [(ngModel)]="item.name" #name="ngModel" name="name" maxlength="100"
               [required]="shouldEditName(item.designationTypeCode)" [disabled]="!shouldEditName(item.designationTypeCode)">
        <validation-message [control]="name"></validation-message>
      </div>
    </div>


    <div class="col-sm-12">
      <div class="form-group">
        <!-- File observations-->
        <label for="Observations">{{'CardDocumentation.DocumentsTable.Observations' | translate}}</label>
        <input class="form-control" type="text" placeholder="{{'CardDocumentation.DocumentsTable.ObservationsPlaceholder' | translate}}" [(ngModel)]="item.observation" #observation="ngModel" name="observation" maxlength="100" />

        <validation-message [control]="observation"></validation-message>
      </div>
    </div>
  </div>

</form>

<form *ngIf="!isVersion2()" name="tableItemEditForm" #tableItemEditForm="ngForm">
  <div class="row">

    <div class="col-sm-6" *ngIf="!isMandatoryDocumentation">
      <div class="form-group" *ngIf="!item.isMandatoryFile">
        <label for="DesignationTypeCode"><span class="mandatory">*</span>{{'CardDocumentation.DocumentsTable.Designation' | translate}}</label>
        <select class="custom-select" [(ngModel)]="item.designationTypeCode" name="designationTypeCode" #designationTypeCode="ngModel" required
                [dropdownTitle]="{value : item.designationTypeCode, dimensions : designationTypes }" nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of getFilteredDesignationTypes()" [value]="domain.code">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="designationTypeCode"></validation-message>
      </div>
    </div>

    <!--<div class="col-sm-6">
      <div class="form-group">
        <label for="FileType"><span class="mandatory">*</span>{{'CardDocumentation.DocumentsTable.FileType' | translate}}</label>
        <select class="custom-select" [(ngModel)]="item.extensionTypeCode" name="extensionTypeCode" #extensionTypeCode="ngModel" required
                [dropdownTitle]="{value : item.extensionTypeCode, dimensions : fileTypes }" nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of fileTypes" [value]="domain.code">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="extensionTypeCode"></validation-message>
      </div>
    </div>-->


    <div class="col-sm-12" *ngIf="isMandatoryDocumentation">
      {{item.description}}
    </div>

    <div class="col-sm-12" [hidden]="!((item.fileID && isEdit) || uploadedFile)">
      <div class="fileinput-custom-1" (click)="downloadDocument()">
        <div class="content-file-wrapper">
          <div class="d-flex align-items-center">
            <span class="icon-doc"></span>
            <span class="text-file">
              <p class="m-0 text-filename">{{item.fileName}}</p>
              <p class="m-0 min-text">{{item.fileSizeKB}}KB</p>
            </span>
          </div>

          <button type="button" class="btn-icon text-primary hide-on-fieldset" aria-label="Editar" (click)="onClearFile(isEdit)">
            <span class="p-1 text-primary icon-trash"></span>
            &nbsp;Limpar
          </button>

        </div>
      </div>
    </div>


    <div class="col-sm-12" [hidden]="item.fileID || uploadedFile">
      <div class="fileinput-custom-2" appDrag (files)="onFileDropped($event)">
        <i class="icon-upload text-primary" aria-hidden="true"></i>
        <span>
          <label class="fileinput-bold-text">{{'CardDocumentation.DocumentsTable.File' | translate}}&nbsp;</label>
          <input class="form-control" type="file" id="input-file" #file name="file" accept="application/pdf" onclick="value = null" (change)="onFileSelected($event)" [required]="true" style="display: none;">
          <a class="text-secondary"><label for="input-file" class="fileinput-bold-text"> {{'CardDocumentation.DocumentsTable.Find' | translate}}</label></a>
        </span>
        <span class="fileinput-custom-text-responsive">{{'CardDocumentation.DocumentsTable.ValidNameMessage1' | translate}}</span>
        <span class="fileinput-custom-text-responsive">{{'CardDocumentation.DocumentsTable.ValidNameMessage2' | translate}}</span>
        <span class="fileinput-custom-text-responsive">{{'CardDocumentation.DocumentsTable.ExtensionAndSize1' | translate}}</span>
        <span class="fileinput-custom-text-responsive">{{'CardDocumentation.DocumentsTable.ExtensionAndSize2' | translate}}</span>
        <span *ngIf="invalidFileSize" class="fileinput-custom-text-responsive" style="color:red">O ficheiro que pretende adicionar está vazio</span>
        <span *ngIf="invalidFileFormat" class="fileinput-custom-text-responsive" style="color:red">O formato do ficheiro que pretende adicionar não corresponde à sua extensão!</span>
        <validation-message [control]="file"></validation-message>
      </div>
    </div>

    <div class="col-sm-1">&nbsp;</div>

    <div class="col-sm-6">
      <div class="form-group" [ngClass]="shouldEditName(item.designationTypeCode) ? '' : 'disabled'">
        <!-- File description type inputs-->
        <label for="Name"><span class="mandatory" *ngIf="shouldEditName(item.designationTypeCode)">*</span>{{'CardDocumentation.DocumentsTable.Name' | translate}}</label>
        <input class="form-control" type="text" [(ngModel)]="item.name" #name="ngModel" name="name" maxlength="100"
               [required]="shouldEditName(item.designationTypeCode)" [disabled]="!shouldEditName(item.designationTypeCode)">
        <validation-message [control]="name"></validation-message>
      </div>
    </div>


    <div class="col-sm-12">
      <div class="form-group">
        <!-- File observations-->
        <label for="Observations">{{'CardDocumentation.DocumentsTable.Observations' | translate}}</label>
        <input class="form-control" type="text" placeholder="{{'CardDocumentation.DocumentsTable.ObservationsPlaceholder' | translate}}" [(ngModel)]="item.observation" #observation="ngModel" name="observation" maxlength="100" />

        <validation-message [control]="observation"></validation-message>
      </div>
    </div>
  </div>

</form>

<div class="d-flex justify-content-between mt-4 mb-2">
  <button [disabled]="removeDisabled()" type="button" class="btn btn-outline-primary disable-on-fieldset" (click)="onRemove(isEdit)">
    <span [ngClass]="isEdit ? 'icon-trash' : 'icon-close'"></span>
    <span>{{isEdit ?  'Remover' : 'Cancelar'}}</span>
  </button>
  <button type="button" [disabled]="!item.file" class="btn btn-primary disable-on-fieldset" aria-label="Aplicar" (click)="onEdit(isEdit)"><span class="icon-check"></span><span>Aplicar</span></button>
</div>
